// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__GTZ7Y","content":"styles_content__1GVj0","tableWrap":"styles_tableWrap__1eB8f"};